var _FontAwesomeIcon, _FontAwesomeIcon2, _FontAwesomeIcon3, _FontAwesomeIcon4;
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
var styles = {
  "wrapper": "pbui-BDQJ6",
  "previous--wrapper": "pbui-huX0N",
  "previous--wrapper--disabled": "pbui-qtWuq",
  "previous--wrapper--enabled": "pbui-Svkas",
  "previous--text": "pbui-trVqz",
  "pages--wrapper": "pbui-3nFN9",
  "page--wrapper": "pbui-gnhBO",
  "page--wrapper--selected": "pbui-zNCYm",
  "page--wrapper--regular": "pbui-v-IkV",
  "page--wrapper--separator": "pbui-yq87D",
  "page--wrapper--not--separator": "pbui-P7nB0",
  "page--text": "pbui-PzRJd",
  "page--wrapper--centered": "pbui-lAuIf",
  "page--wrapper--white": "pbui--mRtl"
};
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// 0 <= currentPage <= totalNumberOfPage is valid scope for currentPage
// Why 0? Well when currentPage is 0, then no page is selected
var PaginationV2Links = function PaginationV2Links(_ref) {
  var totalNumberOfPages = _ref.totalNumberOfPages,
    currentPage = _ref.currentPage,
    previousLink = _ref.previousLink,
    getPageLink = _ref.getPageLink,
    nextLink = _ref.nextLink,
    _ref$customSeparator = _ref.customSeparator,
    customSeparator = _ref$customSeparator === void 0 ? '...' : _ref$customSeparator;
  if (totalNumberOfPages < 1 || currentPage < 0 || totalNumberOfPages < currentPage) {
    return null;
  }
  var getPageNumbers = function getPageNumbers() {
    if (totalNumberOfPages <= 5) {
      return Array.from({
        length: totalNumberOfPages
      }, function (_, i) {
        return i + 1;
      });
    }
    if (currentPage < 3) {
      return [1, 2, 3, customSeparator, totalNumberOfPages];
    }
    if (currentPage === 3) {
      return [1, 2, 3, 4, customSeparator, totalNumberOfPages];
    }
    if (currentPage > totalNumberOfPages - 2) {
      return [1, customSeparator, totalNumberOfPages - 2, totalNumberOfPages - 1, totalNumberOfPages];
    }
    if (currentPage === totalNumberOfPages - 2) {
      return [1, customSeparator, totalNumberOfPages - 3, totalNumberOfPages - 2, totalNumberOfPages - 1, totalNumberOfPages];
    }
    return [1, customSeparator, currentPage - 1, currentPage, currentPage + 1, customSeparator, totalNumberOfPages];
  };
  var previousWrapperClasses = clsx(styles['previous--wrapper'], styles['previous--wrapper--disabled']);
  var previousWrapperLinkClasses = clsx(styles['previous--wrapper'], styles['previous--wrapper--enabled']);
  var pageWrapperClasses = clsx(styles['page--wrapper'], styles['page--wrapper--centered']);
  var pageWrapperDisabledClasses = clsx(styles['page--wrapper'], styles['page--wrapper--white']);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['wrapper'],
    children: [currentPage === 1 || currentPage === 0 ? /*#__PURE__*/_jsxs("button", {
      disabled: true,
      className: previousWrapperClasses,
      children: [_FontAwesomeIcon || (_FontAwesomeIcon = /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: faArrowLeft,
        width: 12
      })), /*#__PURE__*/_jsx("span", {
        className: styles['previous--text'],
        children: "Previous"
      })]
    }) : /*#__PURE__*/_jsxs("a", {
      href: previousLink,
      className: previousWrapperLinkClasses,
      children: [_FontAwesomeIcon2 || (_FontAwesomeIcon2 = /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: faArrowLeft,
        width: 12
      })), /*#__PURE__*/_jsx("span", {
        className: styles['previous--text'],
        children: "Previous"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['pages--wrapper'],
      children: getPageNumbers().map(function (page, index) {
        return /*#__PURE__*/_jsx(React.Fragment, {
          children: typeof page === 'number' ? /*#__PURE__*/_jsx("a", {
            href: getPageLink ? getPageLink(page) : '/',
            className: "".concat(pageWrapperClasses, " ").concat(currentPage === page ? styles['page--wrapper--selected'] : styles['page--wrapper--regular']),
            children: /*#__PURE__*/_jsx("span", {
              className: styles['page--text'],
              children: page
            })
          }) : /*#__PURE__*/_jsx("button", {
            disabled: true,
            className: pageWrapperDisabledClasses,
            children: /*#__PURE__*/_jsx("span", {
              className: styles['page--text'],
              children: page
            })
          })
        }, index);
      })
    }), currentPage === totalNumberOfPages ? /*#__PURE__*/_jsxs("button", {
      disabled: true,
      className: previousWrapperClasses,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles['previous--text'],
        children: "Next"
      }), _FontAwesomeIcon3 || (_FontAwesomeIcon3 = /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: faArrowRight,
        width: 12
      }))]
    }) : /*#__PURE__*/_jsxs("a", {
      href: nextLink,
      className: previousWrapperLinkClasses,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles['previous--text'],
        children: "Next"
      }), _FontAwesomeIcon4 || (_FontAwesomeIcon4 = /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: faArrowRight,
        width: 12
      }))]
    })]
  });
};
export default PaginationV2Links;